{
  "name": "m3-stadium",
  "seed": 1,
  "track": "stadium",
  "fixedDtMs": 16.666666666666668,
  "cars": [{ "id": "player", "spawn": { "x": 680, "y": 190, "angle": 0 }, "ai": null }],
  "inputs": [],
  "captures": []
}
